var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"d-data-table",attrs:{"headers":_vm.tableHeaders,"items":_vm.tableItems,"item-class":"cssClass","loading":_vm.loading,"loader-height":2,"disable-pagination":"","hide-default-footer":"","dense":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }